import { render, staticRenderFns } from "./unauthorized-layout.vue?vue&type=template&id=7e9a40d4&"
import script from "./unauthorized-layout.ts?vue&type=script&lang=js&"
export * from "./unauthorized-layout.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports